import { translate } from './TranslateComponent';


export const formsErrorRenderer = translate('formField')(
    ({ error, t }) => t(error),
);
